var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.4 20.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #3571d6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.4,20.7v-6.3c0-1.8.3-3.5,1-5.3.7-1.8,1.6-3.5,2.7-5,1.1-1.6,2.3-2.9,3.5-3.9l5.8,3.2c-1,1.6-1.8,3.3-2.4,5.1-.6,1.8-.9,3.7-.9,6v6.3H1.4ZM15.3,20.7v-6.3c0-1.8.3-3.5,1-5.3.7-1.8,1.6-3.5,2.7-5,1.1-1.6,2.3-2.9,3.5-3.9l5.8,3.2c-1,1.6-1.8,3.3-2.4,5.1-.6,1.8-.9,3.7-.9,6v6.3h-9.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.5c5d8041e62fcfea0527058dbec83694.svg";
export { ForwardRef as ReactComponent };